<template>
  <div class="contact">
    <!-- 头部 -->
    <v-header></v-header>
    <!-- 广告 -->
    <div class="banner" @click="dialogVisible = true"></div>
    <!-- 选项 -->
    <div class="change">
      <div>
        <h1 class="content-h2-title"> {{ $t("message.corporatecontent.title") }} </h1>
      </div>
      <!-- 内容 -->
      <div class="change_content">
        <div class="center">
          <p>{{ $t("message.corporatebanner.p") }}</p>
          <div
            style="
              display: flex;
              flex-wrap: wrap;
              justify-content: space-around;
              text-align: center;
            "
          >
            <div class="c1">
              <div class="c1-bg1">
                <i>
                  <img
                    src="../assets/images/icon_派對icon-10.png"
                    alt
                    width="60px"
                    height="60px"
                  />
                </i>
                <span>Partyroom</span>
                <div class="c1-bg"></div>
              </div>
              <p>{{ $t("message.corporatecontent.span1") }}</p>
              <el-button type="success" @click="dialogVisible = true">
                {{ $t("message.corporatecontent.btn") }}
              </el-button>
            </div>
            <div class="c1">
              <div class="c1-bg2">
                <i>
                  <img
                    src="../assets/images/icon_活動策劃icon.png"
                    alt
                    width="60px"
                    height="60px"
                  />
                </i>
                <span>{{ $t("message.corporatecontent.pic2") }}</span>
                <div class="c1-bg"></div>
              </div>
              <p>{{ $t("message.corporatecontent.span2") }}</p>
              <el-button type="success" @click="dialogVisible = true">
                {{ $t("message.corporatecontent.btn") }}
              </el-button>
            </div>
            <div class="c1">
              <div class="c1-bg3">
                <i>
                  <img
                    src="../assets/images/icon_小朋友 icon.png"
                    alt
                    width="60px"
                    height="60px"
                  />
                </i>
                <span>{{ $t("message.corporatecontent.pic3") }}</span>
                <div class="c1-bg"></div>
              </div>
              <p>{{ $t("message.corporatecontent.span3") }}</p>
              <el-button type="success" @click="dialogVisible = true">
                {{ $t("message.corporatecontent.btn") }}
              </el-button>
            </div>
            <div class="c1">
              <div class="c1-bg4">
                <i>
                  <img
                    src="../assets/images/icon_健身icon.png"
                    alt
                    width="60px"
                    height="60px"
                  />
                </i>
                <span>{{ $t("message.corporatecontent.pic4") }}</span>
                <div class="c1-bg"></div>
              </div>
              <p>{{ $t("message.corporatecontent.span4") }}</p>
              <el-button type="success" @click="dialogVisible = true">
                {{ $t("message.corporatecontent.btn") }}
              </el-button>
            </div>
            <div class="c1">
              <div class="c1-bg5">
                <i>
                  <img
                    src="../assets/images/icon_醫院icon.png"
                    alt
                    width="60px"
                    height="60px"
                  />
                </i>
                <span>{{ $t("message.corporatecontent.pic5") }}</span>
                <div class="c1-bg"></div>
              </div>
              <p>{{ $t("message.corporatecontent.span5") }}</p>
              <el-button type="success" @click="dialogVisible = true">
                {{ $t("message.corporatecontent.btn") }}
              </el-button>
            </div>
            <div class="c1">
              <div class="c1-bg6">
                <i>
                  <img
                    src="../assets/images/icon_餐廳icon.png"
                    alt
                    width="60px"
                    height="60px"
                  />
                </i>
                <span>{{ $t("message.corporatecontent.pic6") }}</span>
                <div class="c1-bg"></div>
              </div>
              <p>{{ $t("message.corporatecontent.span6") }}</p>
              <el-button type="success" @click="dialogVisible = true">
                {{ $t("message.corporatecontent.btn") }}
              </el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- SEO -->
    <div class="center seo1">
      <div class="cc-seo">
        <h2>
          <img src="../assets/images/pc_hz_title_line1.png" alt />
          {{ $t("message.corporatecontent.seoh1") }}
          <img src="../assets/images/pc_hz_title_line2.png" alt />
        </h2>
        <div>
          <div>
            <img
              src="../assets/images/pc_hz_daohui_img.png"
              height="50%"
              width="100%"
              alt
            />
          </div>
          <div>
            <p>{{ $t("message.corporatecontent.seop1") }}</p>
            <p>{{ $t("message.corporatecontent.seop2") }}</p>
            <p>{{ $t("message.corporatecontent.seop3") }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="seomo">
      <div>
        <img src="../assets/images/hz_cooperation_rec.png" alt />
        {{ $t("message.corporatecontent.seoh1") }}
      </div>
      <div class="seomof">
        <div>
          <img src="../assets/images/pc_hz_daohui_img.png" alt width="100%" />
        </div>
        <div style="font-size: 13px">
          <p>
            {{ $t("message.corporatecontent.seop1")
            }}{{ $t("message.corporatecontent.seop2")
            }}{{ $t("message.corporatecontent.seop3") }}
          </p>
        </div>
      </div>
    </div>
    <el-dialog :visible.sync="dialogVisible" width="810px">
      <el-form
        :label-position="labelPosition"
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form
          :label-position="labelPosition"
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          class="demo-ruleForm"
        >
          <p class="banner-call2">
            {{ $t("message.corporatecontent.dialog.h1") }}
          </p>
          <el-form-item
            :label="$t('message.corporatecontent.dialog.namelabel')"
            prop="name"
          >
            <el-input
              :placeholder="
                $t('message.corporatecontent.dialog.nameplaceholder')
              "
              v-model="ruleForm.name"
            ></el-input>
          </el-form-item>
          <el-form-item
            :label="$t('message.corporatecontent.dialog.emaillabel')"
            prop="email"
          >
            <el-input
              :placeholder="
                $t('message.corporatecontent.dialog.emailplaceholder')
              "
              v-model="ruleForm.email"
            ></el-input>
          </el-form-item>
          <el-form-item
            :label="$t('message.corporatecontent.dialog.phonelabel')"
            prop="phone"
          >
            <el-input
              :placeholder="
                $t('message.corporatecontent.dialog.phoneplaceholder')
              "
              v-model="ruleForm.phone"
            ></el-input>
          </el-form-item>
          <el-form-item
            :label="$t('message.corporatecontent.dialog.conlabel')"
            prop="con"
          >
            <el-input
              v-model="ruleForm.con"
              :placeholder="
                $t('message.corporatecontent.dialog.conplaceholder')
              "
            ></el-input>
          </el-form-item>
          <el-form-item
            :label="$t('message.corporatecontent.dialog.coolabel')"
            prop="coo"
          >
            <el-input
              v-model="ruleForm.coo"
              :placeholder="
                $t('message.corporatecontent.dialog.cooplaceholder')
              "
            ></el-input>
          </el-form-item>
        </el-form>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="show">
          <a :href="href" style="color: #fff; text-decoration: none">
            {{ $t("message.corporatecontent.dialog.btn1") }}
          </a>
        </el-button>
        <el-button @click="dialogVisible = false">
          {{ $t("message.corporatecontent.dialog.btn2") }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import $ from "jquery";
import header from "../components/header";
export default {
  name: "index",
  data() {
    return {
      activeName: "Christmas Parties",
      i: true,
      dialogVisible: false,
      labelPosition: "right",
      ruleForm: {
        name: "",
        email: "",
        phone: "",
        con: "",
        coo: ""
      },
      href: "",
      rules: {
        name: [
          { required: true, message: "請輸入您的稱呼", trigger: "blur" },
          { min: 3, max: 5, message: "长度在 3 到 5 个字符", trigger: "blur" }
        ],
        email: [
          { required: true, message: "請輸入電郵", trigger: "blur" },
          { type: "email", message: "格式不對", trigger: "blur" }
        ],
        phone: [
          { required: true, message: "請輸入聯絡方式", trigger: "blur" },
          {
            pattern: /^[1][3-8]\d{9}$|^([6|9])\d{7}$|^[0][9]\d{8}$|^[6]([8|6])\d{5}$/,
            message: "請輸入正確的手機號碼格式"
          }
        ]
      }
    };
  },
  methods: {
    handleClick(tab, event) {},
    chil() {
      if (this.i === true) {
        $(".phone-header-top").css("overflow", "inherit");
        this.i = false;
      } else if (this.i === false) {
        $(".phone-header-top").css("overflow", "hidden");
        this.i = true;
      }
    },
    show() {
      this.href =
        "https://api.whatsapp.com/send?phone=85264586539&text=hello%20到會家,我想瞭解一些合作的相關事宜%0A稱呼:" +
        this.ruleForm.name +
        "%0A電郵：" +
        this.ruleForm.email +
        "%0A聯係方式：" +
        this.ruleForm.phone +
        "%0A公司：" +
        this.ruleForm.con +
        "%0A合作形式：" +
        this.ruleForm.coo +
        "！😋";
    }
  },
  components: {
    "v-header": header,
  }
};
</script>
<style lang="less" scoped>
.content-h2-title {
  text-align: center;
  font-weight: 500;
  font-size: 32px;
  margin: 10px 0;
}

.content-h3-title {
  text-align: center;
  margin: 10px 0;
  font-size: 20px;
}
.contact .banner {
  height: 600px;
  background: url("../assets/images/pc_hz_banner.png");
  background-size: 100% 100%;
}
.contact .change_content .center > p {
  display: block;
  font-size: 20px;
}
/* 页头 */
.move,
.seomo {
  display: none;
}
.center,
.center.seo1 {
  width: 1180px;
  height: 100%;
  margin: auto;
  overflow: hidden;
}
.h-bottom-l ul,
.h-bottom-r > span {
  font-size: 0.85rem;
  color: #eb6410;
}
.h-bottom-r .el-button.el-button--success {
  color: white;
}
/* 广告 */
.banner .el-button.el-button--success {
  display: block;
  width: 20rem;
  margin: 2% auto 0 auto;
  background: #eb6410;
  border: 1px solid #eb6410;
}
.banner {
  margin: 110px 0;
  position: relative;
  width: 100%;
}
.banner h1,
.banner p {
  text-align: center;
  color: white;
}
.banner h1 {
  font-weight: bold;
  font-size: 50px;
}
.banner p {
  margin: 1% 0;
  font-size: 15px;
}
.banner-call2 {
  text-align: center;
  color: #eb6410;
  letter-spacing: 0;
  font-weight: 300;
  margin: 0 0 3% 0;
  font-size: 1.1rem;
}
.banner .center {
  width: 80%;
  height: 40%;
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 3;
  margin: auto;
}
.banner .el-dialog__body {
  padding: 0 50px;
}
/* 选择 */
.change {
  width: 1180px;
  margin: 3% auto;
}
.el-tabs__nav-wrap .el-tabs__nav-scroll .el-tabs__nav {
  width: 1180px;
  display: flex;
  justify-content: space-around;
}
.el-tabs__item:hover {
  color: #eb6410 !important;
  cursor: pointer;
}
.el-tabs__active-bar {
  background-color: #eb6410 !important;
}
.el-tabs__item.is-active {
  color: #eb6410 !important;
}
.row {
  margin-right: -0.9375rem;
  margin-left: -0.9375rem;
}
.row:before,
.row:after {
  display: table;
  content: " ";
}
.row-l,
.row-r {
  width: 50%;
  float: left;
}
.row-r > div {
  width: 45%;
  float: left;
  margin: 0 2% 5%;
}
.figure-text {
  height: 15px;
  text-align: left;
  display: block;
  border-radius: 0 0 3px 3px;
  background: #fff;
  padding: 16px 20px;
  border: 1px solid #dfe0e0;
  border-top: none;
  box-shadow: 0px 1px 2px 0px rgba(20, 20, 21, 0.05);
}
.figure-text h5 {
  font-size: 15px;
  color: #141415;
  margin-bottom: 0;
  font-family: "geomanist_regularregular", sans-serif;
  font-weight: normal;
  float: left;
  line-height: 15px;
}
/* 服务 */
.service {
  background: #fff;
  margin: 3% 0;
}
.service h2,
.service p {
  text-align: center;
}
.service h2 {
  font-size: 40px;
  font-family: "geomanistbook", sans-serif;
  font-weight: 500;
  color: #141415;
  margin: 5% 0 1% 0;
}
.service p {
  font-size: 20px;
  margin: 0 0 5% 0;
}
.service-d {
  display: flex;
  flex-wrap: nowrap;
  justify-content: center;
}
.service-d > div {
  width: 33.33%;
  padding: 0 3%;
}
.service-d > div {
  text-align: center;
}
.service-d h3 {
  font-weight: 500;
  font-size: 17px;
  color: #141415;
  line-height: 25px;
  margin: 3% 0;
}
.service .el-button.el-button--success {
  display: block;
  margin: 3% auto;
  background: #eb6410;
  border: 1px solid #eb6410;
}
/* 内容 */
.change_content {
  padding: 0 0 3rem 0;
  border-bottom: 1px solid #dbdbdb;
}
.change_content .center > p {
  line-height: 7rem;
  font-size: 1.5rem;
  color: #515154;
  text-align: center;
  height: 7rem;
  font-weight: bold;
}
.c1 > div {
  height: 163px;
  background-size: 100%;
  position: relative;
}
.change_content .c1 {
  width: 390px;
  box-sizing: border-box;
  padding: 0 1%;
  margin: 0 0 2% 0;
}
.c1 a {
  text-decoration: none;
  color: white;
}
.c1-bg {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  background: rgba(20, 20, 21, 0.5);
}
.c1-bg1 {
  background: url("../assets/images/partyroom.png") no-repeat;
}
.c1-bg2 {
  background: url("../assets/images/hdch.png") no-repeat;
}
.c1-bg3 {
  background: url("../assets/images/child.png") no-repeat;
}
.c1-bg4 {
  background: url("../assets/images/jianshen.png") no-repeat;
}
.c1-bg5 {
  background: url("../assets/images/guan.png") no-repeat;
}
.c1-bg6 {
  background: url("../assets/images/canting.png") no-repeat;
}
.c1-bg1 > i,
.c1-bg2 > i,
.c1-bg3 > i,
.c1-bg4 > i,
.c1-bg5 > i,
.c1-bg6 > i,
.c1-bg1 > span,
.c1-bg2 > span,
.c1-bg3 > span,
.c1-bg4 > span,
.c1-bg5 > span,
.c1-bg6 > span {
  position: absolute;
  z-index: 3;
  color: white;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  margin: auto;
}
.c1-bg1 > i,
.c1-bg2 > i,
.c1-bg3 > i,
.c1-bg4 > i,
.c1-bg5 > i,
.c1-bg6 > i {
  font-size: 1.5rem;
  height: 4.8rem;
}
.c1-bg1 > span,
.c1-bg2 > span,
.c1-bg3 > span,
.c1-bg4 > span,
.c1-bg5 > span,
.c1-bg6 > span {
  font-size: 0.9rem;
  height: 0rem;
  margin-top: 30%;
}
.c1 > p {
  padding: 5%;
  line-height: 1.5rem;
  font-size: 0.78rem;
  color: rgb(81, 81, 84);
}
.c1 .el-button.el-button--success {
  background: #eb6410;
  border: 1px solid #eb6410;
  margin: 2% 0;
}
.contact .cc-seo {
  /* height: 300px; */
  margin: 0 0 70px 0;
}
.cc-seo h2 {
  font-size: 20px;
  text-align: center;
  color: #212121;
  font-weight: 300;
  margin: 20px 0;
}
.cc-seo h1 > img {
  padding: 0 0 5px 0;
}
.cc-seo p {
  margin: 2% auto;
  font-size: 14px;
  width: 100%;
  text-indent: 2rem;
}
.cc-seo > div {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  width: 90%;
  margin: auto;
  align-items: center;
  /* float: left;
  width: 50%;
  height: 100%; */
}
.cc-seo > div > div:nth-child(1) {
  flex: 0 0 40%;
}
.cc-seo > div > div:nth-child(2) {
  flex: 0 0 59%;
  color: #919599;
}
.cc-seo > div > div:nth-child(2) {
  padding: 20px 50px;
  box-sizing: border-box;
}
.cc-seo > div > div:nth-child(3) {
  color: #919599;
}
/* 移动端 */
@media (max-width: 820px) {
  .contact .banner {
    height: 200px;
    background: url("../assets/images/hz_banner.png");
    background-size: 100% 100%;
  }
  .contact .change_content .center > p {
    font-size: 0.9rem;
    display: none;
  }
  .center.seo1 {
    display: none;
  }
  .seomo {
    display: block;
    margin: 40px 20px;
    /* height: 150px; */
  }
  .seomof {
    /* overflow: hidden; */
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  }
  .seomof > div {
    flex: 0 0 100%;
  }
  .seomof {
    margin: 10px 0;
  }
  .seomof p {
    color: #919599;
    margin-top: 20px;
    box-sizing: border-box;
    padding: 0 0px;
    word-break: break-all;
    text-overflow: ellipsis;
    overflow: hidden;
    display: -webkit-box;
    /* -webkit-line-clamp: 6; */
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
  .cc-seo h1 {
    font-size: 1.4rem;
  }
  .cc-seo p {
    width: 100%;
    font-weight: 400;
    padding: 0 3%;
    box-sizing: border-box;
  }
  .banner {
    background: url("../assets/images/hz_banner.png");
    background-size: 100% 100%;
  }
  .banner p {
    font-size: 12px;
  }
  /* .change {
      margin: 10% 0;
    } */
  .c1-bg1 > i,
  .c1-bg2 > i,
  .c1-bg3 > i,
  .c1-bg4 > i,
  .c1-bg5 > i,
  .c1-bg6 > i {
    height: 7rem;
  }
  .move {
    display: block;
  }
  .change_content .center > div {
    flex-wrap: wrap;
  }
  .change_content .c1 {
    flex: 1 0 100%;
    padding: 3% 5%;
  }
  .c1 > div {
    height: 165px;
  }
  .center {
    width: 100%;
  }
  .parameter {
    height: 280px;
  }
  .banner .center {
    width: 95%;
    height: 141px;
  }
  .banner .center h1 {
    font-size: 1.5rem;
  }
  .banner .el-button.el-button--success {
    display: block;
    width: 14rem;
    margin: 5% auto 0 auto;
  }
  .change {
    width: 100%;
  }
  .banner {
    margin: 135px 0 0 0;
    height: 170px;
  }
  .service-d {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
    text-align: center;
  }
  .service h2 {
    font-size: 25px;
  }
  .service p {
    font-size: 14px;
    padding: 0 4%;
  }
  .service-d > div {
    width: 100%;
  }
}
</style>
<style>
.v-modal {
  display: none;
}
@media (max-width: 1200px) {
  .change {
    width: 90% !important;
    margin: 3% auto;
  }
  .contact .center {
    width: auto !important;
  }
  .change_content .center > p {
    line-height: 30px !important;
  }
}
@media (max-width: 1000px) {
  .cc-seo > div > div:nth-child(1),
  .cc-seo > div > div:nth-child(2) {
    flex: 0 0 100% !important;
  }
}
@media (max-width: 820px) {
  .contact .el-dialog__body {
    padding: 0 20px 0 0;
  }
  .contact .el-dialog {
    z-index: 100 !important;
    width: 100% !important;
    margin-top: 15vh !important;
  }
  .contact.el-carousel__indicators--horizontal {
    display: none;
  }
  .contact .c1 .el-button.el-button--success[data-v-34e39e40] {
    margin: 1% 0;
  }
}
.contact .el-button.el-button--primary {
  border: 1px solid #eb6410;
  background: #eb6410;
}
.contact .el-dialog__footer {
  text-align: center;
}
@media (max-width: 768px) {
}
</style>
